module.exports = __webpack_public_path__ + "static/media/TlnMediaGroup_Canada.3327d021.jpg";